<template>
    <div :class="compact ? 'skin-order-compact-title' : 'skin-order-heading'">
        <template v-if="!compact">
            <span class="skin-order-art" :data-scene="scene" aria-hidden="true"></span>
            <p v-if="isTransferFlow" class="skin-order-step">{{ $t('skinDetails.stepOf', { step: hashPhase ? 2 : 1, total: 2 }) }}</p>
        </template>
        <component :is="compact ? 'span' : 'h2'">{{ title }}</component>
        <p v-if="!compact && isTransferFlow">{{ $t(hashPhase ? 'skinDetails.hashIntro' : 'skinDetails.transferIntro') }}</p>
    </div>
</template>
<script>
// Presentation-only derivation of the existing order state. No API or actions.
export default {
    name: 'OrderHeading',
    props: {
        order: { type: Object, default: () => ({}) },
        step: { type: Number, default: 1 },
        compact: Boolean
    },
    computed: {
        hashPhase() { return this.step === 2 || ['Paying', 'Fail'].includes(this.order.rechargeOrderState) },
        isTransferFlow() { return !!this.order.usdtAmt && ['WaitPay', 'Paying', 'Fail'].includes(this.order.rechargeOrderState) },
        scene() { return this.isTransferFlow ? (this.hashPhase ? 'hash' : 'usdt') : 'summary' },
        title() { return this.$t(this.isTransferFlow ? (this.hashPhase ? 'skinDetails.confirmTransaction' : 'skinDetails.usdtDeposit') : 'DepositDetails.DepositDetails') }
    }
}
</script>
